import { getAvatarUrl } from "../../avatars";

export default function PlayReconnectModal({
  selectedPlayer,
  reconnectPassword,
  setReconnectPassword,
  reconnectError,
  reconnectLoading,
  onReconnect,
  onBypass,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="bg-slate-900 border border-white/10 rounded-2xl p-5 w-full max-w-sm shadow-2xl">
        <h2 className="text-lg font-semibold mb-2">
          Reconnexion au profil{" "}
          <span className="text-indigo-300">{selectedPlayer.pseudo}</span>
        </h2>
        <p className="text-xs text-gray-400 mb-3">
          Entrez le mot de passe choisi au moment de la création de ce profil, ou
          utilisez le mode &quot;mot de passe oublié&quot; pour forcer la connexion.
        </p>

        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-full overflow-hidden bg-indigo-500/20 flex items-center justify-center font-semibold">
            {selectedPlayer.avatar ? (
              <img
                src={getAvatarUrl(selectedPlayer.avatar)}
                alt={selectedPlayer.pseudo}
                className="w-full h-full object-contain"
              />
            ) : (
              <span>{selectedPlayer.pseudo?.slice(0, 1)?.toUpperCase() || "?"}</span>
            )}
          </div>
          <div>
            <div className="text-sm font-semibold">{selectedPlayer.pseudo}</div>
            <div className="text-[11px] text-gray-400">Profil joueur existant</div>
          </div>
        </div>

        <label className="block text-sm font-medium text-gray-300 mb-1">
          Mot de passe
        </label>
        <input
          type="password"
          value={reconnectPassword}
          onChange={(e) => setReconnectPassword(e.target.value)}
          placeholder="Votre mot de passe"
          className="w-full p-2.5 bg-gray-900 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:ring-2 focus:ring-indigo-500 focus:outline-none text-sm"
        />

        {reconnectError && (
          <div className="mt-3 rounded-lg border border-red-500/30 bg-red-500/10 text-red-300 text-xs px-3 py-2">
            {reconnectError}
          </div>
        )}

        <div className="mt-4 flex flex-col gap-2">
          <button
            type="button"
            onClick={onReconnect}
            disabled={reconnectLoading || !reconnectPassword.trim()}
            className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-500 rounded-lg text-sm font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {reconnectLoading ? "Connexion..." : "Se reconnecter"}
          </button>

          <button
            type="button"
            onClick={onBypass}
            disabled={reconnectLoading}
            className="w-full py-2.5 bg-transparent border border-amber-400/60 text-amber-200 rounded-lg text-xs font-semibold hover:bg-amber-500/10 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Mot de passe oublié / forcer la connexion
          </button>

          <button
            type="button"
            onClick={onClose}
            disabled={reconnectLoading}
            className="w-full py-2 text-xs text-gray-400 hover:text-gray-200"
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}